import { createFileRoute } from "@tanstack/react-router";
import { ChatPanel } from "@/components/chat/ChatPanel";

/** Global conversation: set up new projects, ask across projects. */
export const Route = createFileRoute("/_app/chat")({
  component: () => (
    <div className="mx-auto h-[calc(100vh-49px)] max-w-3xl">
      <ChatPanel projectId={null} className="h-full" placeholder="Describe a new project, or ask where things stand..." />
    </div>
  ),
});
